import React, { useState, useEffect } from "react";
import "./Thread.css";

function Thread({ threads, onNewReply, username, setUsernamePopup }) {
  // Top-level threads (parentId === null)
  const topLevelThreads = threads.filter((thread) => thread.parentId === null);

  // Local state for replies per thread ID
  const [repliesMap, setRepliesMap] = useState({});

  // Fetch replies for a thread ID
  const fetchReplies = async (threadID) => {
    try {
      const res = await fetch(
        `${process.env.REACT_APP_BASE_URL}/thread/replies/${threadID}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );

      if (!res.ok) throw new Error("Failed to fetch replies");

      const data = await res.json();

      // data.replies is an array, store it in repliesMap for this threadID
      setRepliesMap((prev) => ({
        ...prev,
        [threadID]: data.replies || [],
      }));
    } catch (err) {
      console.error("Error fetching replies:", err);
    }
  };

  
  useEffect(() => {
  topLevelThreads.forEach((thread) => {
    fetchReplies(thread.id);
  });
}, [topLevelThreads]);
  
  const handleSubmit = async (e, threadId) => {
    e.preventDefault();
    if (!username) {
      setUsernamePopup(true);
      return;
    }

    const replyContent = e.target.replyContent.value;
    if (!replyContent.trim()) return;

    const newReply = {
      content: replyContent,
      username,
      timestamp: new Date().toISOString(),
      songID: threads.find((t) => t.id === threadId)?.spotifySongID || null,
    };

    try {
      const res = await fetch(
        `${process.env.REACT_APP_BASE_URL}/thread/${threadId}/reply`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
          body: JSON.stringify(newReply),
        }
      );

      if (!res.ok) {
        const errorText = await res.text();
        throw new Error(errorText || "Reply failed");
      }

      const { thread } = await res.json();
      onNewReply(threadId, thread);
    } catch (err) {
      console.error("Error posting reply:", err.message);
    }

    e.target.reset();
  };

  return (
    <div className="thread-container">
      <div className="threads-list">
        {topLevelThreads.map((thread) => (
          <div key={thread.id} className="thread">
            <div className="thread-header">
              <strong>{thread.username}</strong> -{" "}
              <span>{new Date(thread.timestamp).toLocaleString()}</span>
            </div>
            <p>{thread.content}</p>

            {/* Render replies if any */}
            {repliesMap[thread.id] && repliesMap[thread.id].length > 0 && (
              <div className="replies">
                {repliesMap[thread.id].map((reply) => (
                  <div key={reply.id} className="reply">
                    <div className="reply-header">
                      <strong>{reply.username}</strong> -{" "}
                      <span>{new Date(reply.timestamp).toLocaleString()}</span>
                    </div>
                    <p>{reply.content}</p>
                  </div>
                ))}
              </div>
            )}

            <form onSubmit={(e) => handleSubmit(e, thread.id)}>
              <input
                type="text"
                name="replyContent"
                placeholder="Add a reply..."
                required
              />
              <button type="submit">Reply</button>
            </form>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Thread;
